<template>
<v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
        <v-col cols="12">
            <i-card-vertical headerTitle= "5.3 Delivery List By Period" >
                <template v-slot:body>
                    <v-layout column overflow-auto>
                        <v-row dense>
                            <v-col cols="12" class="pa-0">
                                <i-card-top class="d-md-flex" outlined :useBtnList="[
                                    'btnRetrieve', //Retrieve
                                    'btnExcel'
                                ]" @btnRetrieve="doSearchMain()" @btnExcel="onExporting()">
                                    <template v-slot:body>
                                        <v-layout column>
                                            <v-row no-gutters class="center pa-2 pb-0">
                                                <v-icon small color="blue">mdi-circle</v-icon>
                                                <span class="pa-1 subTitle">Period : </span>
                                                <v-col cols="2">
                                                    <DxDateBox :value="startDate" height="30px" display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                        @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}" />
                                                </v-col>
                                                <span class="pa-1 subTitle"> ~ </span>
                                                <v-col cols="2">
                                                    <DxDateBox :value="endDate" height="30px" display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                        @value-changed="e => {reqDtFrom = e.value && getEndFormat(e.value)}" />
                                                </v-col>
                                                <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                                                <span class="pa-1 subTitle"> Warehousing : </span>
                                                <v-col cols="2">
                                                <v-select v-model="whYn.select" :items="whYn.items" item-text="name" item-value="cd" return-object single-line outlined
                                                    dense />
                                                </v-col>                                                
                                                <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                                                <span class="pa-1 subTitle"> Final Weight : </span>
                                                <v-col cols="2">
                                                     <v-select
                                                        v-model="fnWeight.select"
                                                        :items="fnWeight.items"
                                                        item-text="name"
                                                        item-value="cd"  
                                                        return-object
                                                        single-line                             
                                                        outlined
                                                        dense />
                                                </v-col>
                                            </v-row>
                                        </v-layout>
                                    </template>
                                </i-card-top>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" class="pa-0">
                                <v-row no-gutters>
                                    <v-col class="d-flex justify-end" style="color: #0000ff; font-weight: bold;">
                                            <span>
                                            (Inclueded V.A.T )
                                            </span>
                                        </v-col>
                                </v-row>
                                <DxDataGrid id="epms5020" class="listBox" :ref="epms5020Ref"
                                    :data-source="gridMainList" :remote-operations="false" :hover-state-enabled="true"
                                    :allow-column-resizing="true" :allow-column-reordering="true"
                                    :row-alternation-enabled="true" :show-borders="true" :width="grid.width"
                                    :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                                    :column-hiding-enabled="false" :selection="{ mode: 'none' }"                                     
                                    data-row-template="dataRowTemplate" >
                                                                        
                                    <DxColumn data-field="delyDte" caption="Delivery Plain Date" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center" :visible="true" header-cell-template = "deliDte"/>
                                    <template #deliDte >
                                        <div>Delivery<br/>Plain Date</div>
                                    </template>
                                    <DxColumn data-field="delyNo" caption="Delivery No" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center"  />                                   
                                    <DxColumn data-field="seq2" caption="No" width="5%" data-type="string" :allow-editing="false"
                                        alignment="left"  />
                                    <DxColumn  caption="Ship No" width="12%" data-type="string" :allow-editing="false"
                                        alignment="center"  >
                                        <DxColumn data-field="shipNo" caption="Por No" width="12%" data-type="string" :allow-editing="false" alignment="center" />
                                    </DxColumn>
                                    <DxColumn caption="Material Code" width="15%" data-type="string" :allow-editing="false"
                                        alignment="center" >
                                        <DxColumn data-field="matlCd" caption="P.O No" width="15%" data-type="string" alignment="center" :allow-editing="false" />
                                    </DxColumn>
                                    <DxColumn data-field="matlSpec" caption="Material Specification" width="20%" data-type="string" :allow-editing="false"
                                        alignment="left"  />
                                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" :allow-editing="false"
                                        alignment="center"  />
                                    <DxColumn  caption="Quantity" width="10%" data-type="string" :allow-editing="false"
                                        alignment="right" >
                                        <DxColumn data-field="delyQty" caption="Unit Price	" width="10%" data-type="string" alignment="right" :allow-editing="false"/>
                                    </DxColumn>
                                    <DxColumn  caption="Amout" width="12%" data-type="string" alignment="right" :allow-editing="false" >
                                        <DxColumn data-field="delyAmt" caption="Trans.free" width="12%" data-type="string" alignment="right" :allow-editing="false"/>
                                    </DxColumn>
                                    <DxColumn data-field="govFee" caption="Gov. Fee" width="10%" data-type="string" :allow-editing="false"
                                        alignment="right"  />
                                    <DxColumn data-field="whDte" caption="W/H Date" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center"  />
                                    <DxColumn data-field="finalYn" caption="Final Weight Y/N" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center"  header-cell-template = "fnWeight" />
                                    <template #fnWeight >
                                        <div>Final Weight<br />Y/N</div>
                                    </template>
                                    <template #dataRowTemplate="{data: rowInfo }">
                                        <fragment>
                                            <tr class="main-row">
                                                <td rowspan="2" style="text-align:center">{{ rowInfo.rowIndex == 0 || rowInfo.data.seq1 == 1 ? rowInfo.data.delyDte : '' }}</td>
                                                <td rowspan="2" style="text-align:center">{{ rowInfo.rowIndex == 0 || rowInfo.data.seq2 == 1 ? rowInfo.data.delyNo : '' }}</td>
                                                <td rowspan="2" style="text-align:center">{{ rowInfo.data.seq2 }}</td>
                                                <td style="text-align:center">{{ rowInfo.data.shipNo }}</td>
                                                <td style="text-align:center">{{ rowInfo.data.matlCd }}</td>
                                                <td rowspan="2" >{{ rowInfo.data.matlSpec }}</td>
                                                <td rowspan="2" style="text-align:center">{{ rowInfo.data.matlUnit }}</td>
                                                <td style="text-align:right">{{ formatPrice(rowInfo.data.delyQty) }}</td>
                                                <td style="text-align:right">{{ formatPrice(rowInfo.data.delyAmt) }}</td>
                                                <td style="text-align:right" rowspan="2">{{ formatPrice(rowInfo.data.govFee) }}</td>
                                                <td rowspan="2" style="text-align:center">{{ rowInfo.data.whDte }}</td>
                                                <td rowspan="2" style="text-align:center">{{ rowInfo.data.finalYn }}</td>
                                            </tr>
                                            <tr class="notes-row">
                                                <td style="text-align:center">{{ rowInfo.data.porNo + '-' + rowInfo.data.porSeq }}</td>
                                                <td style="text-align:center ">
                                                     <v-btn ref="thePoBtn" small elevation="0" color="transparent"  class="px-0 py-0 grd-btn" @click.stop="statusByPo">
                                                                {{ rowInfo.data.poNo }}
                                                            </v-btn><br/>
                                                </td>
                                                <td style="text-align:right">{{ formatPrice(rowInfo.data.uprice) }}</td>
                                                <td style="text-align:right">{{ formatPrice(rowInfo.data.transFee) }}</td>                                    
                                            </tr>
                                        </fragment>
                                    
                                    </template> 
                                    <DxPaging :enabled="true" :page-size="8" />
                                </DxDataGrid>

                                <DxDataGrid id="epms5020Xls"  :ref="epms5020XlsRef"
                                    :data-source="gridMainList" :remote-operations="false" :hover-state-enabled="true"
                                    :allow-column-resizing="false" :allow-column-reordering="true"
                                    :row-alternation-enabled="true" :show-borders="true" :width="grid.width" :height="0"
                                    :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                                    :column-hiding-enabled="false" :selection="{ mode: 'none' }"  
                                    @exporting="onExporting"
                                    >                                                                        
                                    <DxColumn data-field="delyDte" caption="Delivery Plain Date" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center" :visible="true" header-cell-template = "deliDte"/>
                                    <template #deliDte >
                                        <div>Delivery<br/>Plain Date</div>
                                    </template>
                                    <DxColumn data-field="delyNo" caption="Delivery No" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center"  />                                   
                                    <DxColumn data-field="seq2" caption="No" width="5%" data-type="string" :allow-editing="false"
                                        alignment="left"  />
                                    <DxColumn data-field="shipNo" caption="Ship No" width="12%" data-type="string" :allow-editing="false"
                                        alignment="center"  />
                                        
                                    <DxColumn data-field="porNo" caption="Por No" width="12%" data-type="string" :allow-editing="false" alignment="center" />

                                    <DxColumn data-field="matlCd"  caption="Material Code" width="15%" data-type="string" :allow-editing="false"
                                        alignment="center" />                                        
                                    
                                    <DxColumn data-field="poNo" caption="P.O No" width="10%" data-type="string" alignment="center" :allow-editing="false" />

                                    <DxColumn data-field="matlSpec" caption="Material Specification" width="20%" data-type="string" :allow-editing="false"
                                        alignment="left"  />
                                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" :allow-editing="false"
                                        alignment="center"  />
                                    <DxColumn data-field="delyQty"  caption="Quantity" width="10%" data-type="string" :allow-editing="false"
                                        alignment="right" />                                                                            
                                    <DxColumn data-field="uprice" caption="Unit Price	" width="10%" data-type="string" alignment="right" :allow-editing="false"/>

                                    <DxColumn data-field="delyAmt" caption="Amout" width="12%" data-type="string" alignment="right" :allow-editing="false" />                                        
                                    
                                    <DxColumn data-field="transFee" caption="Trans.free" width="12%" data-type="string" alignment="right" :allow-editing="false"/>

                                    <DxColumn data-field="govFee" caption="Gov. Fee" width="10%" data-type="string" :allow-editing="false"
                                        alignment="right"  />
                                    <DxColumn data-field="whDte" caption="W/H Date" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center"  />
                                    <DxColumn data-field="finalYn" caption="Final Weight Y/N" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center"  header-cell-template = "fnWeight" />
                                    <template #fnWeight >
                                        <div>Final Weight<br />Y/N</div>
                                    </template>                                    
                                    <DxPaging :enabled="true" :page-size="8" />
                                </DxDataGrid>
                            </v-col>
                        </v-row>
                    </v-layout>
                </template>
            </i-card-vertical>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' 
import { getDeliList } from '@/api/view/hip/5/epms5020.js'
import DxDateBox from 'devextreme-vue/date-box'
import { getDateFormat } from '@/utils/common.js'
import { parseNumber } from 'devextreme/localization'
import { getNumComma } from '@/utils/common.js'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';

export default {
    name: 'epms5020',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox
    },
    data() {
        return {
            gridMainList: [],
            epms5020Ref: "epms5020Ref",
            epms5020XlsRef: "epms5020XlsRef",
            startDate: '',
            endDate: '',
            stDte: '',
            edDte: '',
            //cell merge
            mergeElements: [],
            mergeStartElements: [],            

            nonDispalyedRowIndex: [],
            curRowIndex: 0,
            fnWeight: {
                select: { name: 'All', cd: '%' },
                items: [
                    { name: 'All', cd: '%' },
                    { name: 'Yes', cd: 'Y' },
                    { name: 'No', cd: 'N' }
                ]
            },
            whYn: {
                select: { name: 'All', cd: '%' },
                items: [
                    { name: 'All', cd: '%' },
                    { name: 'Warehousing', cd: 'Y' },
                    { name: 'Not yet Warehousing', cd: 'N' }
                ]
            }
        }
    },

    created() {
        var date = new Date();
        this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.getStrFormat(this.startDate)
        this.getEndFormat(this.endDate) 
        this.doSearchMain();
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms5020Ref)
        },
        gridMainInstance02() {
            return this.GetDataGrid(this.epms5020XlsRef)
        },
    },

    methods: {
        async doSearchMain() {
            this.gridMainList = []
            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                finalYn: this.fnWeight.select.cd,
                whYn: this.whYn.select.cd,
                frDte: this.stDte,
                toDte: this.edDte
            }

            await getDeliList(params).then(res => {
                this.gridMainList = res.list
               
            }).finally(() => {
                
                this.endLoading();
            })
        },
        getStrFormat(date) {         
            this.stDte = getDateFormat(date)   
            return getDateFormat(date)
        },
        getEndFormat(date) {        
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        formatPrice(value) {
            // let val = (parseNumber(value) / 1).toFixed(0).replace('.', ',')
            // return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            return getNumComma(value)
        },
        statusByPo(e) {
           // console.log(e)
        this.$router.push({ name: 'epms5030', params: { poNo: e.srcElement.innerText } });
        },
        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Delivery');    
                   
            exportDataGrid({
                component: this.gridMainInstance02,
                worksheet,
                topLeftCell: { row: 1, column: 1 },
            }).then((cellRange) => {                
                
                const headerRow = worksheet.getRow(1);
                const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
                const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
                let headerRowLength = headerRow._cells.length
                for(let i = 1; i <= headerRowLength; i++){
                headerRow.getCell(i).fill = headerStyle
                headerRow.getCell(i).border = headerBorderStyle
                headerRow.getCell(i).alignment = { horizontal: 'center' }
                }
                for(let j = 2; j <= worksheet._rows.length; j++){
                    for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
                        worksheet.getRow(j).getCell(a).border = headerBorderStyle
                    }
                }
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    console.log()
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Delivery.xlsx');
                });            
                
            });   
            this.gridMainInstance02.cancel = true;          
    }
       
    }
}
</script>

<style scoped>

#epms5020 tr.main-row td {
    height: 20px;
    border: 1px solid rgb(213, 211, 211);
    border-collapse: collapse;
}

#epms5020 tr.notes-row {
    white-space: normal;
    vertical-align: top;
}

#epms5020 tr.notes-row td {
    height: 20px;    
    border: 1px solid rgb(213, 211, 211);
    border-collapse: collapse;
}

</style>